import { wait } from './wait'

/**
 * Polls a check function until it returns truthy or times out.
 *
 * @param checkFn    A function that returns a boolean (or Promise<boolean>) indicating success.
 * @param intervalMs Optional settings for interval and timeout.
 * @param timeoutMs  Optional settings for interval and timeout.
 * @returns          Resolves `true` if the check passes within the timeout; otherwise `false`.
 */
export async function poll(
  checkFn: () => boolean | Promise<boolean>,
  intervalMs = 100,
  timeoutMs = 1000
): Promise<boolean> {
  const start = Date.now()

  while (Date.now() - start < timeoutMs) {
    try {
      if (await checkFn()) {
        return true
      }
    } catch {
      //
    }
    await wait(intervalMs)
  }

  return false
}
